export default __webpack_public_path__ + "static/media/08.dda57932.jpg";